import { defineMessages } from 'react-intl';

export default defineMessages({
  offlinePay: {
    id: 'offlinePay',
    defaultMessage: '线下支付',
  },
  onlinePay: {
    id: 'onlinePay',
    defaultMessage: '在线支付',
  },
  myComment: {
    id: 'comment.myComment',
    defaultMessage: '我的评价',
  },
  commentForCoupon: {
    id: 'comment.commentForCoupon',
    defaultMessage: '评价领券',
  },
  iwantComment: {
    id: 'comment.iwantComment',
    defaultMessage: '我要评价',
  },
  goodComment: {
    id: 'comment.good',
    defaultMessage: '好',
  },
  middleComment: {
    id: 'comment.middleComment',
    defaultMessage: '中',
  },
  poorComment: {
    id: 'comment.poorComment',
    defaultMessage: '差',
  },
  goodScore: {
    id: 'comment.goodScore',
    defaultMessage: '超赞',
  },
  middleScore: {
    id: 'comment.middleScore',
    defaultMessage: '一般',
  },
  poorScore: {
    id: 'comment.poorScore',
    defaultMessage: '很差',
  },
  commentPlaceholder: {
    id: 'comment.commentPlaceholder',
    defaultMessage: '客官，菜品还令你满意吗？说说它的优点和美中不足的地方',
  },
  downloadInvoice: {
    id: 'invoice.downloadInvoice',
    defaultMessage: '下载发票',
  },
  applyForInvoice: {
    id: 'invoice.applyForInvoice',
    defaultMessage: '申请开票',
  },
  invoicing: {
    id: 'invoice.invoicing',
    defaultMessage: '开票中',
  },
  refundFailAndContactMerchant: {
    id: 'refundFailAndContactMerchant',
    defaultMessage: '退款失败，请联系商户',
  },
  orderIsCanceledText: {
    id: 'orderIsCanceledText',
    defaultMessage: '订单已取消',
  },
  minutes: {
    id: 'time.minutes',
    defaultMessage: '分',
  },
  seconds: {
    id: 'time.seconds',
    defaultMessage: '秒',
  },
  autoInvalidated: {
    id: 'time.autoInvalidated',
    defaultMessage: '{time}后自动作废',
  },
  forgetIt: {
    id: 'forgetIt',
    defaultMessage: '算了',
  },
  cancelOrder: {
    id: 'cancelOrder',
    defaultMessage: '取消订单',
  },
  suerForCancelOrder: {
    id: 'suerForCancelOrder',
    defaultMessage: '确认要取消订单吗？',
  },
  coupon: {
    id: 'coupon',
    defaultMessage: '优惠劵',
  },
  itsYourCoupon: {
    id: 'itsYourCoupon',
    defaultMessage: '客官！是你的优惠劵',
  },
  clickForGetCoupon: {
    id: 'clickForGetCoupon',
    defaultMessage: '点击领取',
  },
  redEnvelopes: {
    id: 'redEnvelopes',
    defaultMessage: '发红包',
  },
  getShareRedEnvelopes: {
    id: 'getShareRedEnvelopes',
    defaultMessage: '客官！恭喜你获得分享红包',
  },
  clickForShare: {
    id: 'clickForShare',
    defaultMessage: '点击分享',
  },
  takeMealNum: {
    id: 'takeMealNum',
    defaultMessage: '取餐号',
  },
  numberPlate: {
    id: 'numberPlate',
    defaultMessage: '号牌',
  },
  takeMealCode: {
    id: 'takeMealCode',
    defaultMessage: '核销码',
  },
  takeMeal: {
    id: 'takeMeal',
    defaultMessage: '取餐',
  },
  today: {
    id: 'today',
    defaultMessage: '今天',
  },
  orderDetail: {
    id: 'orderDetail',
    defaultMessage: '订单详情',
  },
  merchantResponse: {
    id: 'merchantResponse',
    defaultMessage: '商家回复',
  },
  commentTheOrder: {
    id: 'commentTheOrder',
    defaultMessage: '请对订单进行评价',
  },
  tasteScoreText: {
    id: 'tasteScoreText',
    defaultMessage: '口味',
  },
  serviceScoreText: {
    id: 'serviceScoreText',
    defaultMessage: '服务',
  },
  environmentScoreText: {
    id: 'environmentScoreText',
    defaultMessage: '环境',
  },
  getCommentCoupon: {
    id: 'getCommentCoupon',
    defaultMessage: '恭喜获得评价领券',
  },
  getCommentCoupInfo: {
    id: 'getCommentCoupInfo',
    defaultMessage: '恭喜获得{sendCoupInfo}',
  },
  goToView: {
    id: 'goToView',
    defaultMessage: '去查看',
  },
  getCommentGifts: {
    id: 'getCommentGifts',
    defaultMessage: '恭喜获得评价专属礼包',
  },
  getSpendGifts: {
    id: 'getSpendGifts',
    defaultMessage: '恭喜您获得消费礼包',
  },
  sendYouCoupon: {
    id: 'sendYouCoupon',
    defaultMessage: '优惠券5分钟内由系统账户发放到您的账户',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/dinner-detail/index.js